import React from "react";
import { HOME_FEATURE_BLOCKS } from "../lib/demoLandingFixtures";
import { Button, TextLink } from "./ui";

export default function HomeFeatureMatrix({ onTryDemo }) {
  return (
    <section className="mb-14 lg:mb-20" data-testid="home-feature-matrix">
      <div className="flex flex-col gap-12 lg:gap-16">
        {HOME_FEATURE_BLOCKS.map((block) => (
          <div key={block.id} data-testid={`home-feature-${block.id}`}>
            <h2 className="font-display font-semibold text-[clamp(1.35rem,3.5vw,1.75rem)] leading-tight text-ink text-balance">
              {block.title}
            </h2>
            <p className="mt-2 max-w-xl text-[15px] font-normal text-ink/65 text-pretty">{block.subtitle}</p>
            <ul className="mt-8 grid gap-6 sm:grid-cols-2 sm:gap-x-10 sm:gap-y-8">
              {block.items.map((item) => (
                <li key={item.title}>
                  <p className="font-ui font-medium text-[14px] text-ink">{item.title}</p>
                  <p className="mt-1.5 text-[13px] font-normal leading-relaxed text-ink/60 text-pretty">{item.body}</p>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="mt-12 flex flex-col items-start gap-3 sm:items-center sm:text-center">
        {typeof onTryDemo === "function" ? (
          <Button
            type="button"
            variant="primary"
            size="lg"
            data-testid="home-feature-try-demo"
            onClick={onTryDemo}
          >
            Back to tonight&apos;s demo →
          </Button>
        ) : null}
        <TextLink to="/for-organizers" data-testid="home-feature-for-organizers">
          Full host toolkit →
        </TextLink>
      </div>
    </section>
  );
}
